import { Card } from "../styles";
import Footer from "./footer";
import Header from "./header";

const Layout = (props: any) => {
  const { children } = props;
  return (
    <>
      <Header />
      <Card>{children}</Card>
      <Footer />
    </>
  );
};

export default Layout;
